var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.7054 19.031C12.7054 20.6708 11.3761 22.0001 9.73635 22.0001C8.09661 22.0001 6.76733 20.6708 6.76733 19.031C6.76733 17.3913 8.09661 16.062 9.73635 16.062C11.3761 16.062 12.7054 17.3913 12.7054 19.031Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.87059 2.1562C8.65071 1.88688 9.39836 2.63454 9.12905 3.41465L7.34568 8.58044C7.1071 9.27152 6.22735 9.47425 5.71038 8.95729L2.32796 5.57487C1.81099 5.0579 2.01373 4.17815 2.70481 3.93957L7.87059 2.1562Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.83863 8.11462C3.1285 8.40449 3.1285 8.87446 2.83863 9.16433L2.24575 9.75721C0.72043 11.2825 1.62735 13.8949 3.76971 14.147C4.55445 14.2393 5.33827 13.9672 5.89699 13.4085L9.21148 10.094C10.8678 8.43764 13.5532 8.43764 15.2096 10.094C16.8659 11.7503 16.8659 14.4357 15.2096 16.092L14.2199 17.0817C13.93 17.3716 13.46 17.3716 13.1702 17.0817C12.8803 16.7918 12.8803 16.3219 13.1702 16.032L14.1598 15.0423C15.2364 13.9657 15.2364 12.2203 14.1598 11.1437C13.0833 10.0671 11.3378 10.0671 10.2612 11.1437L6.9467 14.4582C6.06671 15.3381 4.83222 15.7667 3.59626 15.6213C0.222073 15.2243 -1.20631 11.1099 1.19605 8.7075L1.78893 8.11462C2.0788 7.82475 2.54876 7.82475 2.83863 8.11462Z"
});

function SvgTrip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrip);
export default __webpack_public_path__ + "static/media/trip.32b9e330.svg";
export { ForwardRef as ReactComponent };